import { ListeningOn } from './types';

export function mapListeningOptions(listenOn: ListeningOn[]) {
    if (Array.isArray(listenOn)) {
        return listenOn.map((value) => {
            // If Contentful document string then parse JSON and get the headline property
            if (value.startsWith('{')) {
                const parsed = JSON.parse(value);
                return parsed?.headline;
            }
            // Else we use the legacy content
            else {
                return value;
            }
        });
    } else {
        return [];
    }
}
